import React, { useEffect } from 'react';
import { FaBed, FaTree,FaAccusoft,FaSwimmingPool,FaDoorOpen,FaTv } from 'react-icons/fa';
import { RiEyeLine, RiHome2Line, RiWifiLine, RiArrowRightLine, RiUserLine, RiTimeLine } from 'react-icons/ri';
// import './FeaturesIcons.css';
import { useLanguage } from '../contexts/LanguageContext';
import SeparatorLine from '../assets/photos/sep3.png';

const FeatureGrid = () => {
  const { t } = useLanguage();
  useEffect(() => {
    const importCss = async () => {
      try {
        await import('./FeaturesIcons.css');//replacing the css with the css of the gallery of the suites
      } catch (err) {}
    };
    importCss();
  }, []);
  const featureIcons = [
    FaSwimmingPool,
    RiUserLine,
    FaBed,
    FaAccusoft,
    RiHome2Line,
    FaDoorOpen,
    FaTv,
    RiWifiLine,
    FaTree,
    RiTimeLine
  ];

  const featureItems = t('features.items');

  return (
    <div className="feature-container">
      <img src={SeparatorLine} className="separator" alt="Separator Line" />
      <h3>{t('features.title')}</h3>
      <div className="feature-grid">
        {featureItems.map((featureName, index) => (
          <div className="feature" key={index}>
            <div className="icon-text">
              <div className="icon">
                {React.createElement(featureIcons[index])}
              </div>
              <div className="name">{featureName}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  ); 
};

export default FeatureGrid;